module.exports = __webpack_public_path__ + "img/dots_rup_4.2e516d35.png";